module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "id": _vm.id,
      "required": _vm.isRequired
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _c('CommentBlock', {
    attrs: {
      "label": _vm.label,
      "name": _vm.name,
      "field_data": _vm.getDeficiencyField
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', _vm._l((_vm.headers), function(header) {
    return (_vm.headers) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (header.label),
        expression: "header.label"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": "disabled"
      },
      domProps: {
        "value": (header.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(header, "label", $event.target.value)
        }
      }
    }), _vm._v(" "), _vm._l((_vm.field_data), function(field, row_no) {
      return _c('div', {
        staticClass: "grid-item"
      }, _vm._l((field), function(title, key) {
        return (key == header.name) ? _c('div', {
          key: ("f_" + key),
          attrs: {
            "id": "header.name",
            "name": (_vm.name + "::" + (header.name))
          }
        }, [(header.type === 'date') ? _c('div', [_c('input', {
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "id": header.name + '::' + row_no,
            "disabled": header.readonly,
            "name": _vm.name + '::' + header.name,
            "placeholder": "DD/MM/YYYY",
            "v-model": _vm.setDateValue(title.value, row_no, header.name, header.readonly),
            "required": _vm.isRequired
          }
        })]) : _vm._e(), _vm._v(" "), (header.type === 'string') ? _c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (title.value),
            expression: "title.value"
          }],
          staticClass: "form-control",
          attrs: {
            "disabled": header.readonly,
            "type": "text",
            "id": header.name + '::' + row_no,
            "name": _vm.name + '::' + header.name,
            "required": _vm.isRequired
          },
          domProps: {
            "value": (title.value)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(title, "value", $event.target.value)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (header.type === 'number') ? _c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (title.value),
            expression: "title.value"
          }],
          staticClass: "form-control",
          attrs: {
            "disabled": header.readonly,
            "id": header.name + '::' + row_no,
            "type": "text",
            "name": _vm.name + '::' + header.name,
            "required": _vm.isRequired
          },
          domProps: {
            "value": (title.value)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(title, "value", $event.target.value)
            }
          }
        })]) : _vm._e()]) : _vm._e()
      }), 0)
    })], 2) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddRow),
      expression: "showAddRow"
    }],
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRow()
      }
    }
  }, [_vm._v("Add Row")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00122534"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/grid.vue
// module id = 908
// module chunks = 0